import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { Router } from '@angular/router';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from './base-list';
import { ControlListType, FormConfigEntryType, FormModelModel } from 'projects/core/src/lib/models/form-model.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FormHelper } from '../shared/form-helper';
import { SelectItem } from 'primeng/api';

export class BaseFormList extends BaseList {

  public inEdit = false;
  public submitting = false;
  public form: UntypedFormGroup = this.fb.group({});
  public models: Array<any> = [];
  public options: { [key: string]: Array<SelectItem> } = {};
  public formConfig: Array<FormConfigEntryType> = [];
  protected controls: Array<ControlListType> = [];

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
    protected fb: UntypedFormBuilder
  ) {
    super(router, ui, helper, transloco, auth);
  }

  public clearModels(): void {
    this.models = [];
  }

  public clearControls(): void {
    this.controls = [];
  }

  public addControls(controls: ControlListType): void {
    this.controls.push(controls);
  }

  public onEdit(): void {
    this.inEdit = true;
    this.enableControls();
  }

  public onCancel(): void {
    this.inEdit = false;
    this.disableControls();
    this.resetControls();
    this.ui.hideMessage();
  }

  public isValid(): boolean {
    let valid = true;
    this.controls.forEach((controls: ControlListType) => {
      Object.keys(controls).forEach((key: string) => {
        if (controls[key].control.valid !== true) {
          valid = false;
        }
      });
    });
    return valid;
  }

  public setBackendErrors(fielderrors: any = null): void {
    if (fielderrors !== null) {
      Object.keys(fielderrors).forEach((key: string) => {
        const id = parseInt(key);
        if (!isNaN(id)) {
          const model = this.models.find(model => model.model?.id === id);
          if (model !== undefined) {
            FormHelper.setBackendErrors(model.form, fielderrors[key]);
          }
        }
      });
    }
  }

  public markAsDirty(): void {
    this.controls.forEach((controls: ControlListType) => {
      Object.keys(controls).forEach((key: string) => {
        controls[key].control.markAsDirty();
      });
    });
  }

  protected getPayload(formTemplate: FormModelModel): any {
    const payload: any = {};
    this.formConfig.forEach((entry: FormConfigEntryType) => {
      const fallBack = entry.type === 'checkbox' ? false : null;
      payload[entry.id] = formTemplate.getControlValue(entry.id) || fallBack;
    });
    return payload;
  }

  protected disableControls(): void {
    this.controls.forEach((controls: ControlListType) => {
      Object.keys(controls).forEach((key: string) => {
        controls[key].control.disable();
        controls[key].control.markAsUntouched();
        controls[key].control.markAsPristine();
      });
    });
  }

  protected enableControls(): void {
    this.controls.forEach((controls: ControlListType) => {
      Object.keys(controls).forEach((key: string) => {
        controls[key].control.enable();
      });
    });
  }

  protected resetControls(): void {
    this.controls.forEach((controls: ControlListType) => {
      Object.keys(controls).forEach((key: string) => {
        controls[key].control.setValue(controls[key].value);
      });
    });
  }

  protected setOptions(options: { [key: string]: Array<string> } | null) {
    if (options !== null) {
      Object.keys(options).forEach((key: string) => {
        this.options[key] = options[key].map((option: string) => {
          return {
            value: option,
            label: this.transloco.translate('common.options.' + key + '.' + option),
          };
        });
      });
    }
    const values = [0, 1, 2, 3, 4, 5];
    this.options['observers_amount'] = values.map((value) => {
      return {
        value,
        label: value.toString()
      };
    });
  }

}
